export default __webpack_public_path__ + "assets/f51c3a281791249258d898c13c6b537b.woff2";